import type {
  MobilePlanOffer,
  MobilePlanPartnerName,
} from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'

import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'

import { getSelectedMobilePlanCartItem } from './getSelectedMobilePlanCartItem'

export function getSelectedMobilePlan(
  items: CartItem[],
  options?: {
    partnerName?: MobilePlanPartnerName
    type?: MobilePlanOffer['type']
  },
): MobilePlanOffer | undefined {
  return getSelectedMobilePlanCartItem(items, options)?.mobilePlan
    ?.selectedOffer
}
